export default {
  messageThreadInputSendAMessage: 'Send a message',
  submitButtonAriaLabel: 'Submit Button',
};
